import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axiosConfig from 'utils/axiosConfig'
import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import { Box, Grid, Paper, Typography, Button } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

const StudentAttempts = (props) => {
  const examid = props.match.params.exam
  const [exam, setExam] = useState({})
  const [attempts, setAttempts] = useState([])
  const [totalPoints, setTotalPoints] = useState(0)

  useEffect(() => {
    getExamination()
  }, [])

  const getExamination = () => {
    axiosConfig.get(`student-examinations/${examid}`)
      .then((response) => {
        const responseData = response.data

        if (!responseData.success) {
          console.log(responseData.message)
          return
        }

        setExam(responseData.examination)
      })

    axiosConfig.get(`student-examinations/${examid}/attempts`)
      .then((response) => {
        const responseData = response.data

        if (!responseData.success) {
          console.log(responseData.message)
          return
        }

        setAttempts(responseData.attempts)
        setTotalPoints(responseData.totalPoints)
      })
  }

  const hasVerifiedAttempt = () => {
    return attempts.filter((a) => a.verified).length > 0
  }

  return (
    <ResponsiveLayout>
      <Grid lg={8} md={6} style={{margin: '0 auto'}}>
        <Paper style={{marginBottom: '20px'}}>
          <Box padding={3}>
            <Link to={`/examinations`}>
              <i className="fa fa-arrow-left"></i> Examinations
            </Link>
            <Typography variant="h6">{exam.name}</Typography>
            <Typography variant="subtitle1">{exam.description}</Typography>
            <Box paddingTop={1} display="flex" whiteSpace={2} gridGap={30}>
              <Box>
                <i className="fa fa-user"></i> Jun Alcantara
              </Box>
              <Box>
                <i className="fa fa-star"></i> {totalPoints} points
              </Box>
            </Box>
          </Box>
        </Paper>

        {attempts?.length > 0 && <>

          {!hasVerifiedAttempt() && <Alert severity="warning" className="mb-4">Validating answers. Please wait for the faculty to validate your answers. One of your submitted attempts will be accepted.</Alert>}

          {hasVerifiedAttempt() && <Alert severity="success" className="mb-4">Your score is 10. You can check the accepted answers below.</Alert>}

        </>}

        {attempts?.length > 0 && attempts.map((attempt, index) => (
          <Paper style={{marginBottom: '20px'}}>
            <Box padding={3} display="flex">
              <Box flexGrow={1} display="flex" justifyContent="center" flexDirection="column">
                <Typography variant="subtitle1">
                  Attempt #{attempts.length - index} {attempt.verified === 1 && <span className="text-green">[<i className="fa fa-check-circle"></i> Accepted]</span>}
                </Typography>
                <Typography variant="button">{attempt.time_submitted}</Typography>
                <Typography variant="caption">Score: {attempt.score}/{totalPoints}</Typography>
              </Box>
              <Box>
                <Link to={`/examinations/${examid}/attempts/${attempt.id}`}>
                  <Button variant="contained" color="primary">
                    <i className="fa fa-eye"></i> &nbsp; View Answers
                  </Button>
                </Link>
              </Box>
            </Box>
          </Paper>
        ))
      }
      {attempts?.length === 0 &&
        <Box marginTop={5} style={{textAlign: 'center'}}>
          <Typography variant="h5">No attempts submitted yet</Typography>
        </Box>
      }
      </Grid>
    </ResponsiveLayout>
  )
}

export default StudentAttempts